import MailboxTabContent from '@src/main/modules/messages/ui/mailbox/components/mailbox/tab/MailboxTabContent';
import styles from '@src/main/modules/messages/ui/mailbox/views/mailbox/Mailbox.module.scss';
import ContentCard from '@src/main/shared/ui/components/card/ContentCard';
import TabHeader from '@src/main/shared/ui/components/header/TabHeader';
import { TabMenuTabChangeEvent } from 'primereact/tabmenu';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Mailbox = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

  const items = [
    { label: t('messages.mailbox.inbox.title'), icon: 'pi pi-inbox' },
    { label: t('messages.mailbox.outbox.title'), icon: 'pi pi-send' },
  ];

  const handleTabChange = (e: TabMenuTabChangeEvent) => {
    setActiveIndex(e.index);
  };

  const handleNewMessage = () => {
    navigate('/messages/new-message');
  };

  return (
    <ContentCard>
      <TabHeader
        title={t('messages.mailbox.title')}
        items={items}
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
        onNew={handleNewMessage}
        buttonLabel={t('messages.mailbox.newMessage.buttonLabel')}
      />
      <MailboxTabContent className={styles['tab-content']} activeIndex={activeIndex} />
    </ContentCard>
  );
};

export default Mailbox;
